<template>
  <div class="rst-confirm">
    <div class="rst-confirm__summary">
      <div class="rst-confirm__item">
        <span class="rst-confirm__label">Total Revenue</span>
        <span class="rst-confirm__value">{{ currency(context.totalRevenue) }}</span>
      </div>
      <div v-if="context.totalPartnerShare !== null" class="rst-confirm__item">
        <span class="rst-confirm__label">Partner Share</span>
        <span class="rst-confirm__value rst-confirm__value--success">
          {{ currency(context.totalPartnerShare) }}
        </span>
      </div>
      <div class="rst-confirm__item">
        <span class="rst-confirm__label">Period</span>
        <span class="rst-confirm__value">{{ context.periodLabel }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { currency } from "./transaction";

export default {
  name: "RevenueSplitTransactionConfirm",

  props: {
    context: { type: Object, required: true },
  },

  methods: { currency },
};
</script>

<style scoped>
.rst-confirm__summary {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}

.rst-confirm__item {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
}

.rst-confirm__label {
  color: #667085;
}

.rst-confirm__value {
  color: #101828;
  font-weight: 600;
}

.rst-confirm__value--success {
  color: #12805c;
}

.rst-confirm__notice {
  display: flex;
  align-items: flex-start;
  background: #fffaeb;
  border: 1px solid #fedf89;
  border-radius: 6px;
  padding: 8px 10px;
}

.rst-confirm__notice-text {
  font-size: 12px;
  color: #93370d;
}
</style>
